module.exports = __webpack_public_path__ + "img/Guatemala.48b1000b.png";